import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaShoppingCart, FaHistory, FaTags, FaUserCircle, FaAddressCard, FaFileInvoiceDollar } from 'react-icons/fa';
import './CustomerDetails.css';

// Dummy data for "experience" role - detailed customer profiles
const dummyExperienceCustomerDetails = {
  'exp_cust_1': {
    id: 'exp_cust_1', first_name: 'Alice', last_name: 'Experience', email: 'alice.exp@example.com', phone: '+1-555-0101',
    orders_count: 15, total_spent: '1250.75', currency: 'EUR',
    default_address: { address1: '123 Experiential Way', address2: 'Apt 4B', city: 'DemoCity', province_code: 'DC', country: 'USA', zip: '90210' },
    tags: ['VIP', 'Frequent Buyer', 'Newsletter Subscriber'],
    orders: [
      { id: 'exp_order_A1', order_number: 'EXP1001', created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'paid', total_price: '75.50', line_items: [{ id: 'li_A1_1', title: 'Experience T-Shirt - Galaxy', quantity: 1, price: '29.99' }, { id: 'li_A1_2', title: 'Experience Mug - Astronaut', quantity: 1, price: '15.99' }] },
      { id: 'exp_order_A2', order_number: 'EXP1002', created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'paid', total_price: '49.99', line_items: [{ id: 'li_A2_1', title: 'Experience Hoodie - Nebula', quantity: 1, price: '49.99' }] },
    ]
  },
  'exp_cust_2': {
    id: 'exp_cust_2', first_name: 'Bob', last_name: 'Demo', email: 'bob.demo@example.com', phone: '+1-555-0102',
    orders_count: 5, total_spent: '340.50', currency: 'EUR',
    default_address: { address1: '456 Virtual Ave', city: 'Testville', province_code: 'TV', country: 'USA', zip: '12345' },
    tags: ['New Customer', 'Promotion User'],
    orders: [
      { id: 'exp_order_B1', order_number: 'EXP2001', created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'partially_refunded', total_price: '120.00', line_items: [{ id: 'li_B1_1', title: 'Experience Backpack - Voyager', quantity: 2, price: '59.99' }] },
    ]
  },
  'exp_cust_3': {
    id: 'exp_cust_3', first_name: 'Carol', last_name: 'Tester', email: 'carol.test@example.com', phone: null, // No phone
    orders_count: 22, total_spent: '2100.00', currency: 'EUR', // Top customer
    default_address: { address1: '789 Example St', city: 'Sampleburg', province_code: 'SB', country: 'USA', zip: '67890' },
    tags: ['Loyal Customer', 'High Spender'],
    orders: [
      { id: 'exp_order_C1', order_number: 'EXP3001', created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'paid', total_price: '150.00', line_items: [{ id: 'li_C1_1', title: 'Experience Desk Mat - Deep Space', quantity: 3, price: '25.00' }, {id: 'li_C1_2', title: 'Experience Water Bottle - SS', quantity: 3, price: '27.99'}] },
      { id: 'exp_order_C2', order_number: 'EXP3002', created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'pending', total_price: '59.99', line_items: [{ id: 'li_C2_1', title: 'Experience Cap - Rocket', quantity: 1, price: '19.99'}, {id: 'li_C2_2', title: 'Experience Socks - Alien Pattern', quantity: 2, price: '12.99'}] },
    ]
  },
   // Add exp_cust_4 and exp_cust_5 with similar structure
  'exp_cust_4': {
    id: 'exp_cust_4', first_name: 'David', last_name: 'Sample', email: 'david.sample@example.com', phone: '+1-555-0104',
    orders_count: 1, total_spent: '45.99', currency: 'EUR',
    default_address: { address1: '101 Unit Test Rd', city: 'Mockville', province_code: 'MV', country: 'USA', zip: '54321' },
    tags: [], // No tags
    orders: [
      { id: 'exp_order_D1', order_number: 'EXP4001', created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'paid', total_price: '45.99', line_items: [{ id: 'li_D1_1', title: 'Experience Keychain - Spaceship', quantity: 2, price: '9.99' }, {id: 'li_D1_2', title: 'Experience Stickers Pack - Cosmic', quantity: 1, price: '7.99'}] },
    ]
  },
  'exp_cust_5': {
    id: 'exp_cust_5', first_name: 'Eve', last_name: 'User', email: 'eve.user@example.com', phone: '+1-555-0105',
    orders_count: 8, total_spent: '680.20', currency: 'EUR',
    default_address: { address1: '222 End User Ln', city: 'Final City', province_code: 'FC', country: 'USA', zip: '00001' },
    tags: ['Early Adopter'],
    orders: [
      { id: 'exp_order_E1', order_number: 'EXP5001', created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'paid', total_price: '250.00', line_items: [{ id: 'li_E1_1', title: 'Experience Puzzle - Earth View', quantity: 5, price: '40.00' }] },
       { id: 'exp_order_E2', order_number: 'EXP5002', created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(), financial_status: 'voided', total_price: '12.99', line_items: [{ id: 'li_E2_1', title: 'Experience Socks - Alien Pattern', quantity: 1, price: '12.99' }] },
    ]
  },
};

const CustomerDetails = () => {
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { customerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const token = sessionStorage.getItem('access_token');
        const userDataString = sessionStorage.getItem('userData');
        let userRole = null;

        if (!token) {
          navigate('/');
          setIsLoading(false);
          return;
        }

        if (userDataString) {
          try {
            userRole = JSON.parse(userDataString).role;
          } catch (parseError) {
            console.error("Failed to parse user data from sessionStorage:", parseError);
          }
        }

        if (userRole === 'experience') {
          console.log(`Experience user detected. Looking for dummy customer details for ID: ${customerId}`);
          const dummyCustomer = dummyExperienceCustomerDetails[customerId];
          if (dummyCustomer) {
            setCustomer(dummyCustomer);
          } else {
            console.warn(`Dummy customer details for ID ${customerId} not found for experience user.`);
            setError(`Details for experience customer ${customerId} not found.`);
            setCustomer(null);
          }
          setIsLoading(false);
          return;
        }

        const response = await axios.get(`/api/shopify/get_customer/${customerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCustomer(response.data);
      } catch (err) {
        console.error("Error fetching customer details:", err);
        setError(err.message);
        if (err.response && (err.response.status === 401 || err.response.status === 422)) {
          sessionStorage.removeItem('access_token');
          sessionStorage.removeItem('userData');
          navigate('/');
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomerDetails();
  }, [customerId, navigate]);

  const handleOrderClick = (orderId) => {
    navigate(`/order/${orderId}`);
  };

  const handleContactCustomer = (method) => {
    switch (method) {
      case 'email':
        window.location.href = `mailto:${customer.email}`;
        break;
      case 'phone':
        window.location.href = `tel:${customer.phone}`;
        break;
      default:
        break;
    }
  };

  if (error) return <div className="una-customer-error">Error: {error}</div>;
  
  if (isLoading) {
    return (
      <div className="una-dashboard-loading-screen">
        <div className="una-loading-content">
          <div className="una-loading-logo">
            <img src="/bgless_logo.png" alt="Unanimity AI Logo" />
          </div>
          <h2>Loading Customer Details</h2>
          <div className="una-loading-progress">
            <div className="una-progress-bar">
              <div className="una-progress-glow"></div>
            </div>
          </div>
          <div className="una-loading-metrics">
            <div className="una-metric-item">
              <FaUser />
              <span>Loading Profile Information</span>
            </div>
            <div className="una-metric-item">
              <FaShoppingCart />
              <span>Fetching Order History</span>
            </div>
            <div className="una-metric-item">
              <FaMapMarkerAlt />
              <span>Processing Address Details</span>
            </div>
            <div className="una-metric-item">
              <FaTags />
              <span>Loading Customer Tags</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="una-customer-error">
         <FaUserCircle size={50} style={{marginBottom: '20px'}} />
        <h2>Customer Not Found</h2>
        <p>{error || `Details for the requested customer could not be loaded.`}</p>
        <button className="una-back-button" onClick={() => navigate('/customers')}>
          <FaArrowLeft /> Back to Customers
        </button>
      </div>
    );
  }

  return (
    <div className="una-customer-details-container">
      <button className="una-back-button" onClick={() => navigate('/customers')}>
        <FaArrowLeft /> Back to Customers
      </button>

      <div className="una-customer-details-grid">
        <div className="una-customer-info-section">
          <div className="una-customer-profile-card">
            <div className="una-customer-avatar">
              <FaUser size={40} />
            </div>
            <h1>{`${customer.first_name} ${customer.last_name}`}</h1>
            <div className="una-customer-stats">
              <div className="una-stat">
                <span className="una-stat-label-customer">Total Orders</span>
                <span className="una-stat-value-customer">{customer.orders_count}</span>
              </div>
              <div className="una-stat">
                <span className="una-stat-label-customer">Total Spent</span>
                <span className="una-stat-value-customer">{customer.total_spent} {customer.currency}</span>
              </div>
              <div className="una-stat">
                <span className="una-stat-label-customer">Average Order</span>
                <span className="una-stat-value-customer">
                  {customer.orders_count > 0 
                    ? `${(parseFloat(customer.total_spent) / customer.orders_count).toFixed(2)} ${customer.currency}`
                    : '0'}
                </span>
              </div>
            </div>
          </div>

          <div className="una-contact-card">
            <h3><FaEnvelope /> Contact Information</h3>
            <div className="una-contact-details">
              <p>{customer.email}</p>
              {customer.phone && <p>{customer.phone}</p>}
              <div className="una-contact-actions">
                <button onClick={() => handleContactCustomer('email')}>
                  <FaEnvelope /> Send Email
                </button>
                {customer.phone && (
                  <button onClick={() => handleContactCustomer('phone')}>
                    <FaPhone /> Call
                  </button>
                )}
              </div>
            </div>
          </div>

          {customer.default_address && (
            <div className="una-address-card">
              <h3><FaMapMarkerAlt /> Default Address</h3>
              <div className="una-address-details">
                <p>{customer.default_address.address1}</p>
                {customer.default_address.address2 && <p>{customer.default_address.address2}</p>}
                <p>{customer.default_address.city}, {customer.default_address.province_code}</p>
                <p>{customer.default_address.country}</p>
                <p>{customer.default_address.zip}</p>
              </div>
            </div>
          )}

          <div className="una-tags-card">
            <h3><FaTags /> Tags</h3>
            <div className="una-customer-tags">
              {Array.isArray(customer.tags) ? customer.tags.map((tag, index) => (
                <span key={index} className="una-customer-tag">
                  {tag.trim()}
                </span>
              )) : null}
            </div>
          </div>
        </div>

        <div className="una-customer-orders-section">
          <div className="una-section-header">
            <h2><FaShoppingCart /> Order History</h2>
          </div>
          
          <div className="una-orders-timeline">
            {customer.orders.map((order) => (
              <div 
                key={order.id} 
                className="una-timeline-order"
                onClick={() => handleOrderClick(order.id)}
              >
                <div className="una-order-date">
                  <FaHistory />
                  {new Date(order.created_at).toLocaleDateString()}
                </div>
                <div className="una-order-card">
                  <div className="una-order-header">
                    <h4>Order #{order.order_number}</h4>
                    <span className={`una-order-status ${order.financial_status}`}>
                      {order.financial_status}
                    </span>
                  </div>
                  <div className="una-order-items">
                    {order.line_items.map((item) => (
                      <div key={item.id} className="una-order-item">
                        <span>{item.title}</span>
                        <span>x{item.quantity}</span>
                        <span>${item.price}</span>
                      </div>
                    ))}
                  </div>
                  <div className="una-order-total">
                    <span>Total</span>
                    <span>${order.total_price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;